namespace RioERP.Invoices {
    export interface OrderSourcesForm {
        SourceType: Serenity.StringEditor;
    }

    export class OrderSourcesForm extends Serenity.PrefixedContext {
        static formKey = 'Invoices.OrderSources';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderSourcesForm.init)  {
                OrderSourcesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(OrderSourcesForm, [
                    'SourceType', w0
                ]);
            }
        }
    }
}
